import React from "react";
import ReactDOM from "react-dom";

import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";
import "themes/styles/postcss/app.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applicationBootstrapper } from "mrb/core";
import { RootStore } from "common/stores";
import ReactGA from "react-ga4";

function startApplication() {
    const configuration = applicationBootstrapper.run(["application"]);
    const rootStore = new RootStore(configuration);

    const rootLoader = document.getElementById("root-loader");
    if (rootLoader) {
        rootLoader.remove();
    }

    renderApplication({ rootStore });
}

function renderApplication({ rootStore }) {
    ReactDOM.render(
        // <React.StrictMode>
        //     <App rootStore={rootStore} />
        // </React.StrictMode>,
        <App rootStore={rootStore} />,
        document.getElementById("root")
    );
}

ReactGA.initialize(ApplicationSettings.gaMeasurementId, {
    gaOptions: {
        send_page_view: false,
    },
});

startApplication();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
